import React from "react";

import { Fonts } from "../../design/Font";

//downward carrot
import u100 from '../../images/hsa-dashboard/u100.png'

/**
 * Dropdown (component)
 * 
 * displays a list of items that can be selected from when toggled.
 * selecting an item changes the value of the dropdown, and triggers
 * an onChange function
 */
export default class Dropdown extends React.Component{
    constructor(props){
        super(props)
        this.state={
            isDropped:false,
            items:[],
            value:null
        }
    }
    componentDidMount=()=>{
        const {items,defaultValue,} = this.props
        this.setState({items:items,value:defaultValue})
    }
    render(){
        const {value,items}=this.state
        return(
            <div style={{cursor:'pointer',position:'relative'}}>
                <div style={this.props.width?{...styles.dropdownContainer,width:this.props.width}:{...styles.dropdownContainer}} onClick={()=>{this.setState({isDropped:!this.state.isDropped})}}>
                    <span style={{...Fonts.text,fontWeight:this.props.noBold?500:'bold'}}>{value}</span>
                    <div style={{display:'flex',alignItems:'center'}}><img alt='carrot' src={u100} style={{transform:this.state.isDropped?'scaleY(1)': 'scaleY(-1)',}}/></div>
                </div>
                {this.state.isDropped?
                    <div style={this.props.width?{...styles.droppedContainer,width:this.props.width}:{...styles.droppedContainer}}>
                        {items.map((item=>item!==this.state.value?<div style={{height:'3vh'}} onClick={()=>{this.setState({value:item,isDropped:false});this.props.onChange(item)}}>
                            <span style={{...Fonts.text}}>{item}</span>    
                        </div>:null))}
                    </div>
                    :null

                }
            </div>
        )
    }

}

const styles={
    dropdownContainer:{
        display:'flex',
        border:'1px solid rgba(215,215,215,1)',
        borderRadius:4,
        paddingTop:"0.5vh",
        paddingBottom:"0.5vh",
        paddingLeft:'0.3vw',
        paddingRight:'0.3vw',
        width:'4.5vw',
        height:"5vh",
        justifyContent:'space-between',
        flexDirection:'row',
        alignItems:'center',
        zIndex:20
    },
    droppedContainer:{
        display:'flex',
        flexDirection:'column',
        borderBottom:'1px solid rgba(215,215,215,1)',
        borderLeft:'1px solid rgba(215,215,215,1)',
        borderRight:'1px solid rgba(215,215,215,1)',
        background:'#ffffff',
        borderBottomLeftRadius:5,
        borderBottomRightRadius:5,
        paddingTop:"0.5vh",
        paddingBottom:"0.5vh",
        paddingLeft:'0.3vw',
        paddingRight:'0.3vw',
        width:'4.5vw',
        position: 'absolute', // Position the dropdown container below the dropdown button
        zIndex: 10, // Ensure the dropdown is above other elements on the screen,
        overflowY:'scroll',
        maxHeight:'10vh'
    },
}